import type React from 'react';

import { useLocation } from 'react-router';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { useNavigate } from '@change-corgi/core-react/router';

import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

export const LoginToAddVideo: React.FC = () => {
	const { track } = useCampaignTracking();
	const { pathname } = useLocation();
	const navigate = useNavigate();

	return (
		<Button
			variant="primary"
			onClick={() => {
				track('campaign_action_create_video_login_click');
				navigate(`/login_or_join?redirectTo=${pathname}`);
			}}
			className="w-full md:w-1/2"
			data-testid="login-to-add-video"
			data-qa="login-to-add-video"
		>
			<Translate value="corgi.petition_actions.invite.log_in_button.label" />
		</Button>
	);
};
